import script from "./customFieldProjectDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldProjectDetail.vue?vue&type=script&setup=true&lang=js"

import "./customFieldProjectDetail.vue?vue&type=style&index=0&id=1c404961&lang=css"

const __exports__ = script;

export default __exports__